import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import moment from 'moment';
import DatePicker from "react-datepicker";
import FilterService from '../../services/filterService';
import CONSTANTS from '../../constants';

import "react-datepicker/dist/react-datepicker.css";

class Filters extends Component {

	renderFields(filters) {
		return _.map(filters, (filter) => {
			return(
				<Field
					key={filter.key}
					name={filter.key}
					filter={filter}
					component={this.getInputField}
				/>
			)
		});
	}

	getInputField(field) {
		let { filter } = field;
		if(filter.type === CONSTANTS.FILTERS.TYPES.DATE) {
			return (
				<div className="form-group">
					<label htmlFor={filter.key} >{filter.label}</label>
					<DatePicker selected={field.input.value}
								onChange={field.input.onChange}
								className='form-control small'
					/>
				</div>
			)
		} else if(filter.type === CONSTANTS.FILTERS.TYPES.STRING) {
            return (
                <div className="form-group">
                    <label htmlFor={filter.key} >{filter.label}</label>
                    <input {...field.input} className="form-control small" />
                </div>
            )
		}
	}

	applyFilters(values) {
		let { filters } = this.props;
		let newFilters = FilterService.getNewFilters(values, filters);
		this.props.callbackToUpdateComponent(newFilters);
	}

	render () {
		let { filters, handleSubmit } = this.props;
		return (
			<div>
				<h4 data-toggle="collapse" data-target="#filters" aria-expanded="false" aria-controls="filters">{this.props.title}</h4>
				<div className="collapse in" id="filters">
					<form className="members-area-form" onSubmit={handleSubmit(this.applyFilters.bind(this))}>
						{this.renderFields(filters)}
						<input type="submit" value="Filter" className="btn btn-primary" /> &nbsp;
					</form>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state, ownProps) {
	let initialValues = {};
	_.map(ownProps.filters, (f) => {
		if(f.type === CONSTANTS.FILTERS.TYPES.DATE) {
			initialValues[f.key] = moment(f.value, CONSTANTS.DATE.FORMAT.DISPLAY).toDate();
		} else {
			initialValues[f.key] = f.value;
		}
	});
	return {initialValues: initialValues};
}

export default (connect(mapStateToProps, null)(reduxForm({form: 'filterForm', enableReinitialize: true })(Filters)))